<template>
  <div>
    <el-card>
        <el-button @click="showAddRoom=true">添加查寝信息</el-button>
        <el-table  :data="resultDate" border show-overflow-tooltip="true" tooltip-effect="dark"
        style="width: 100%">
        <el-table-column prop="message" :show-overflow-tooltip="true" label="留言" width="110">
        </el-table-column>
        <el-table-column prop="roomId" :show-overflow-tooltip="true" label="宿舍号" width="180">
        </el-table-column>
        <el-table-column prop="createDate" :show-overflow-tooltip="true" label="填写时间" width="180">
        </el-table-column>
        
 <el-table-column
      label="查看"
      width="120">
        <template slot-scope="scope" >
<el-button   @click="showsDorm(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-chakan2"></use></svg></el-button>
      </template>
    </el-table-column>
      </el-table>
    </el-card>

    <el-dialog
   title="添加查寝信息"
   :visible.sync="showAddRoom"
   width="50%">
   <el-form :model="addForm" ref="addForms" :rules="addRules" label-width="200px" class="demo-dynamic">
     <el-form-item label="留言：" prop="message">
     <el-input  v-model="addForm.message"></el-input>
   </el-form-item>
   <el-form-item label="宿舍号：" prop="roomId">
     <el-input  v-model="addForm.roomId">
    </el-input>
   </el-form-item>
 </el-form>
   <el-upload
  action="https://jsonplaceholder.typicode.com/posts/"
  list-type="picture-card"
  :show-file-list="true"
  multiple="multiple"
  :limit="3"
  :auto-upload="false"
  :file-list="fileList5"
  accept="image/png,image/gif,image/jpg,image/jpeg"
  :on-success="handleAvatarSuccess"
  :before-upload="beforeAvatarUploads"
  :on-change="handleChanges"
   :on-remove="handleRemoves"
   >
  <img v-if="imageUrl" :src="imageUrl" class="avatar">
  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
</el-upload>
<div>上传文件不能超过2M</div>
<el-button @click="subAddRoom">提交</el-button>
</el-dialog>


<el-dialog
   title="查看查寝信息"
   :visible.sync="showRooms"
   :before-close="handleClose"
   width="50%">
   <el-form  label-width="200px" class="demo-dynamic">
     <el-form-item label="留言：" prop="message">
     <el-input  v-model="showRoom.message"></el-input>
   </el-form-item>
   <el-form-item label="宿舍号：" prop="roomId">
     <el-input  v-model="showRoom.roomId">
    </el-input>
   </el-form-item>
   <el-form-item label="查看时间：" prop="roomId">
     <el-input  v-model="showRoom.createDate">
    </el-input>
   </el-form-item>
 </el-form>
 <div class="imageClass">
 <div v-for="(item, index) in fileListResult"  :key="index + ''">
  <el-image 
    style="width: 150px; height: 150px"
    :src="item"
    :preview-src-list="fileListResult">
  </el-image>
</div>
</div>
 <!-- <img :src="$imagepath+'Dorm/file/8cbed2ce-35e6-410f-aa3c-d73f529d4f481678066107618.jpg'" class="imageClass"> -->
</el-dialog>
  </div>
</template>

<script>
export default {
    data() {
      return {
        imageUrl: '',
        fileList:[],
        fileList5:[],
        fileList6:[],
        resultDate:[],
        showAddRoom:false,
        showRooms:false,
        fileListResult:[],
        showRoom:{
          message:'',
          roomId:'',
          createDate:'',
          fileList:[],
        },
        addForm:{
            message:'',
            roomId:'',
        },
        addRules:{
            message: [
             { min: 0, max: 255, message: '长度在 1 到 255 个字符', trigger: 'blur' }
           ],
           roomId: [
             { required: true, message: '请输入宿舍号', trigger: 'blur' },
             { min: 1, max: 8, message: '长度在 1 到 8 个字符', trigger: 'blur' }
           ],
        }
      };
    },
  created(){
this.getDorm()
    },
    methods: {
      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeAvatarUploads(file) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;
        // if (!isJPG) {
        //   this.$message.error('上传头像图片只能是 JPG 格式!');
        // }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isLt2M;
      },showsDorm(data){
        console.log(data)
        this.showRooms=true
        this.showRoom.message=data.message
         this.showRoom.roomId=data.roomId
          this.showRoom.createDate=data.createDate
          this.getFileList(data.checkDormId)
      },getFileList(useId){
  this.axios.post("/file/getFile?useId="+useId)
          .then(resp => { 
            console.log(resp)
                        if(resp.data.status == 1) {
                          console.log(resp.data)
                          this.fileListResult=[]
                                // this.fileListResult=resp.data.result
                                resp.data.result.forEach(item => {
                                  this.fileListResult.push(this.$imagepath+item.filePath)
                                });
                                console.log(this.fileListResult)
                                 }else {
                                  this.$message.error("获取数据失败")                         
                                 }
                             })
                             .catch((err) => {
                                 alert("出错了")
                                 console.log(err)
                             }) 
      },
      handleChanges(file, fileList) {
       let isTrue= this.beforeAvatarUploads(file)
       if(isTrue){
        this.fileList5=fileList
       }else{
        fileList.splice(fileList.length-1)
       }
        //  return isTrue
    //    this.fileList5=fileList
       },handleRemoves(file, fileList) {
         this.fileList5=fileList
       },
       subAddRoom(){
        this.$refs.addForms.validate(resp=>{
            if(!resp)
            return 
            if(this.fileList5.length <= 0){
            this.$message.error("请选择上传文件") 
          return false
        }else if(this.fileList5.length >= 10){
            this.$message.error("一共上传不超过10个") 
            return false
        }
     const fd = new FormData();
     this.fileList5.forEach((file) => {
          fd.append("filePath", file.raw);
       });
       fd.append("message",this.addForm.message)
       fd.append("roomId",this.addForm.roomId)
       fd.append("userid",JSON.parse(localStorage.getItem("user")).userid)
      console.log(this.fileList6)
      let config = {
         headers: { "Content-Type": "multipart/form-data" }
       };
      this.axios.post("/dorm/insertDorm",fd,config)
          .then(resp => { 
            console.log(resp)
                        if(resp.data.status == 1) {
                                   this.$message.success("添加成功")
                                   this.fileList5=[]
                                   this.fileList6=[]
                                   this.showAddRoom=false
                                   this.getDorm()
                                 }else {
                                   this.$message.error(resp.data.message)
                                   this.fileList6=[]                               
                                 }
                             })
                             .catch((err) => {
                                 alert("出错了")
                                 console.log(err)
                             }) 
        })

       },handleClose(done){
           this.fileListResult=[]
           done();
       },getDorm(){
                this.axios.post("/dorm/getDorm?userid="+JSON.parse(localStorage.getItem("user")).userid)
          .then(resp => { 
            console.log(resp)
                        if(resp.data.status == 1) {
                          console.log(resp.data)
                                this.resultDate=resp.data.result
                                 }else {
                                  this.$message.error("获取数据失败")                         
                                 }
                             })
                             .catch((err) => {
                                 alert("出错了")
                                 console.log(err)
                             }) 
       }
    }
}
</script>

<style>
.imageClass{
 white-space: nowrap;
 display: flex;
justify-content: space-evenly;
}
</style>


// WEBPACK FOOTER //
// src/components/work/student/CheckRoom.vue